import { render, staticRenderFns } from "./client-quotation-preview.vue?vue&type=template&id=4bc86806"
import script from "./client-quotation-preview.vue?vue&type=script&lang=js"
export * from "./client-quotation-preview.vue?vue&type=script&lang=js"
import style0 from "./client-quotation-preview.vue?vue&type=style&index=0&id=4bc86806&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports